"use client";

import { useParams } from "react-router-dom";
import DashboardHeader from "@/components/dashboard-header";
import StudentSearch from "@/components/student-search";

export default function DashboardPage() {
	// `/dashboard/:mssv` mở sẵn một hồ sơ; `/dashboard` thì không có param và trang
	// mở với ô tìm kiếm trống như trước.
	const { mssv } = useParams<{ mssv?: string }>();

	return (
		<div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-blue-950 dark:to-indigo-900">
			<DashboardHeader />

			<div className="container mx-auto p-3 sm:p-4">
				{/* Main Content */}
				<StudentSearch initialMssv={mssv} />
			</div>
		</div>
	);
}
